import React from "react";
import "./Select.css";
import { useTranslation } from "react-i18next";

const Select = ({
  label,
  options,
  name,
  register,
  errors,
  mandatory,
  defaultselect = false,
  disabled = false,
  style,
  placeholder
}) => {
  const { onChange, ...params } = register(name);
  const { t } = useTranslation();

  return (
    <div>
      <label className="form__label">
        {t(label)}
        {mandatory && <span className="asterisk">*</span>}
      </label>
      <select
      style={style}
        className={
          errors[name]
            ? "form-select  form__select--errorborder"
            : "form-select  form__select"
        }
        {...params}
        onChange={onChange}
        disabled={disabled}
        id={name}>
        {defaultselect && (
          <option selected className="text-muted" value="">
            {placeholder || "Select option"}
          </option>
        )}

        {options?.map((option) => (
          <option key={option.value} value={option.value}>
            {t(option.label)}
          </option>
        ))}
      </select>
      <p className="error__message">{errors[name]?.message}</p>
    </div>
  );
};
export default Select;
